export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfCBc4EsA.woff2";